const sortString = (a, b) => String(a).localeCompare(String(b))

export default sortString
